// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t8ri","badges":"styles_badges__2t8Yj"};